import { DateRange, MultiDatePicker, SpecificBlockPicker } from 'Components/organisms/Calendar';
import React, { useEffect, useState } from 'react';

import classNames from 'classnames/bind';
import moment from 'moment-timezone';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function CalendarComponent() {
  const [multiDate, setMultiDate] = useState([]);
  const [selectDate, setSelectDate] = useState(undefined);
  const [description, setDescription] = useState('설명입니다.');
  const [sec, setSec] = useState(2);
  const [open, setOpen] = useState(false);
  return (
    <div className={cx('calendar')}>
      <li>Multi date picker</li>
      <MultiDatePicker onDateChange={(dates) => setMultiDate(dates)} />
      <li>Specific block date picker</li>
      <SpecificBlockPicker
        LunchingDate={multiDate}
        // DefaultDate={moment()}
        DateSelect={(date) => {
          setSelectDate(date);
        }}
      />
      <li>date range picker</li>
      <DateRange />
    </div>
  );
}

export default CalendarComponent;

export const path = '/calendar';
